import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { Filter, Main } from '../../containers';

import {
  getExportFileType,
  getExportFile,
  clearErrors,
} from './state/monthlyexport/actions';
import GenericExportForm from './components/GenericExportForm';
import { GENERIC_EXPORT_FORM_NAME } from 'Common/FormEnum';
import {
  getLoadingFromStore,
  getExportFileTypeFromStore,
  getSubmittingFromStore,
  getErrorFromStore,
} from './state/selectors';
import { GenericExportFieldEnum as Fields } from 'Common/FieldEnum';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { errorToast } from 'Common/ToastHelper';
import { buildFileName } from './helpers';

class GenericExportContainer extends Component {
  formSubmit = values => {
    this.props.getExportFile(
      values,
      buildFileName(this.props.exportFileType, values)
    );
  };

  getMainProps = () => {
    const { loading, submitting } = this.props;
    return {
      toolbox: {
        formName: GENERIC_EXPORT_FORM_NAME,
        saveButtonProps: {
          content: 'Download',
          loading: loading || submitting,
          disabled: loading || submitting,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getExportFileType();
  }

  componentDidUpdate(prevProps) {
    if (errorToast(this.props, prevProps, 'error')) {
      this.props.clearErrors();
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.loading && <LoadingPage />}
        <Filter title={'Generic Export'} />
        <Main {...this.getMainProps()}>
          <GenericExportForm
            onSubmit={this.formSubmit}
            exportFileType={this.props.exportFileType}
            initialValues={{
              [Fields.ExportFileType]: '',
              [Fields.MonthYearDT]: moment().format(MONTH_YEAR_DATE_FORMAT),
              [Fields.PadValuesWithZero]: false,
              [Fields.SelectedSites]: [],
            }}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: getLoadingFromStore(state),
    exportFileType: getExportFileTypeFromStore(state),
    submitting: getSubmittingFromStore(state),
    error: getErrorFromStore(state),
  };
};

export const GenericExport = withRouter(
  connect(
    mapStateToProps,
    { getExportFileType, getExportFile, clearErrors }
  )(GenericExportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/genericexport/GenericExport.js